import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import WOW from 'wowjs';
import { ROUTE } from './Common/constant';
import AutoScrollTop from './Pages/AutoScrollTop';
import ContactUs from './Pages/ContactUs/ContactUs';
import Error from "./Pages/Error/Error";
import HomeOne from "./Pages/HomeOne/HomeOne/HomeOne";
import NewsArticles from './Pages/NewsArticles/NewsArticles';
import NewsArticlesDetail from './Pages/NewsArticles/NewsArticlesDetail';
import Products from './Pages/Products/Products';
import ScrollTop from "./Pages/ScrollTop/ScrollTop";
import Vcard from './Pages/Vcard/Vcard';

function App() {

  useEffect(() => {
    new WOW.WOW({
      mobile: false
    }).init();
  }, []);

  return (
    <>
      <Router>
        <AutoScrollTop />
        <Routes>
          <Route path={ROUTE.BASE_URL} element={<HomeOne />} />
          <Route path={ROUTE.CONTACT_US} element={<ContactUs />} />
          <Route path={ROUTE.PRODUCTS.BASE_URL} element={<Products />} />
          <Route path={ROUTE.PRODUCTS.DETAIL} element={<Products />} />
          <Route path={ROUTE.NEWS_ARTICLES} element={<NewsArticles />} />
          <Route path={ROUTE.NEWS.DETAIL} element={<NewsArticlesDetail />} />
          <Route path={ROUTE.ARTICLES.DETAIL} element={<NewsArticlesDetail />} />
          <Route path={ROUTE.VCARD} element={<Vcard />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
      <ScrollTop />
    </>
  )
}

export default App
